/* --------------------------------------------------------------------------------------
   xwPopover.directive.js
   Copyright © 2021 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

/* eslint semi: ["error", "never"]*/
export class xwPopover {
    /* @ngInject*/
    constructor(appSettings) {
        this.appSettings = appSettings
        this.restrict = 'A'
        this.scope = false
    }
    link(scope, elem, attrs) {
        const options = {
            theme: attrs.theme? attrs.theme : this.appSettings.primaryColor,
            tap: (attrs.tap == 'true'),
            targetControl: attrs.targetControl,
            arrowPosition: attrs.arrowPosition,
            customClass: attrs.customClass,
            height: attrs.height,
            open: () => this.open()
        }

        elem.first().appendTo('body')
        setTimeout(() => elem.first().xrxpopover(options), 70)

        scope.$on('$destroy', () => {
            elem.first().xrxpopover('destroy').remove()
        })
    }
    open() {
        document.activeElement.blur()
    }
    static directiveFactory(appSettings) {
        xwPopover.instance = new xwPopover(appSettings)
        return xwPopover.instance
    }
}



// WEBPACK FOOTER //
// ./src/app/xrxWrappers/xwPopover.directive.js